import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('Browser Window', {
  providedIn: 'root',
  factory: () => window
});
